/**
 * 역할. 기존 D3 서비스의 `RoleType`(API 응답 값)과 같다.
 * 잠정: X3 가 인증 계약을 만들면 `@d3/contract` 로 옮기고 여기서는 다시 내보내기만 한다.
 */
export const ROLE = {
  D3: 'd3',
  LP: 'lp',
  PORTFOLIO: 'portfolio',
  ADMIN: 'admin',
} as const;

export type Role = (typeof ROLE)[keyof typeof ROLE];

export const ROLES: readonly Role[] = Object.values(ROLE);

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && (ROLES as readonly string[]).includes(value);
}
